import { findLocationAnomalies } from "@nova/calculate-geospatial"
import {
    WarningDefinitionData,
    Warnings,
    ID,
    UploadFlowWarnings,
    UploadFlowWarningColors,
} from "@nova/constants"
import { set } from "nodash"
import {
    getNoLocationIds,
    getObliqueIds,
    getThermalDataIds,
    getZoomedIds,
} from "panels/content/side-panel/upload-flow/GenericWarningProcessors"
import { OrthoState } from "./OrthomosaicSlice"

export const orthoWarningDefinitions: WarningDefinitionData = {
    imageType: {
        type: Warnings.Error,
        name: "File Format",
        successMessage: "Accepted file formats",
        successStatus: "Accepted",
    },
    pitch: {
        type: Warnings.Warning,
        name: "Camera Pitch",
        successMessage: "Accepted camera pitch angle",
        successStatus: "Ideal",
    },
    camera: {
        type: Warnings.Error,
        name: "Camera Model",
        successStatus: "Accepted",
        successMessage: "Accepted camera model",
    },
    altitude: {
        type: Warnings.Warning,
        name: "Altitude",
        successMessage: "Flying at the ideal altitude",
        successStatus: "Altitude Ideal",
    },
    resolution: {
        type: Warnings.Warning,
        name: "Resolution",
        successStatus: "High",
        successMessage: "Resolution is at least 640x512",
    },
    visibility: {
        type: Warnings.Error,
        name: "Visibility",
        successStatus: "RGB",
        successMessage: "Images have the correct visibility type",
    },
}

export const OrthoUploadFlowWarnings: Record<
    ID,
    Record<UploadFlowWarnings, { ids: ID[]; color: string }>
> = {}

const addWarning = (
    flightId: string,
    imageColors: Record<ID, string>,
    warning: UploadFlowWarnings,
    ids: ID[]
) => {
    set(OrthoUploadFlowWarnings, flightId + "." + warning, {
        ids,
        color: UploadFlowWarningColors[warning],
    })

    return {
        ...imageColors,
        ...Object.fromEntries(ids.map((id) => [id, UploadFlowWarningColors[warning]])),
    }
}

export const orthoWarningProcessor = (flightId: string, uploads: OrthoState[]) => {
    let imageColors: Record<ID, string> = {}

    //Attention
    const thermalDataIds = getThermalDataIds(uploads)
    if (thermalDataIds.length !== uploads.length)
        imageColors = addWarning(flightId, imageColors, UploadFlowWarnings.IR, thermalDataIds)

    const zoomedIds = getZoomedIds(uploads)
    imageColors = addWarning(flightId, imageColors, UploadFlowWarnings.Zoom, zoomedIds)

    //Warnings
    const obliqueIds = getObliqueIds(uploads)
    imageColors = addWarning(flightId, imageColors, UploadFlowWarnings.Obliques, obliqueIds)

    //Errors
    const noLocationIds = getNoLocationIds(uploads)
    imageColors = addWarning(flightId, imageColors, UploadFlowWarnings.NoLocation, noLocationIds)

    const locationAnomalies = findLocationAnomalies(uploads)
    imageColors = addWarning(flightId, imageColors, UploadFlowWarnings.Location, locationAnomalies)

    return imageColors
}
